import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import auth from "../../services/authService";
import http from "../../services/HttpService";
import config from "../../config.json";
import { getAlert } from "../../services/appAlerts";
import { uploadFileToBlob } from "../../services/blobUploadService";

function UploadInvoice(props) {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleChange = ({ currentTarget: input }) => {
    setData((prev) => ({
      ...prev,
      [input.name]: input.value,
    }));

    if (errors[input.name]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[input.name];
        return next;
      });
    }
  };

  const renderInput = (name, label, type = "text") => (
    <Input
      type={type}
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
    />
  );

  const doSubmit = async () => {
    const user = auth.getCurrentUser();
    const { wfTask: workflowTask, selectedObj, handleInvShowHide } = props;
    let docId = 0;

    if (documents.length > 0) {
      const frmData = new FormData();
      frmData.append("message", data["notes"]);
      frmData.append("workflowTask", JSON.stringify(workflowTask));
      frmData.append("userId", user.id);

      // documents.forEach((file, key) => {
      //   frmData.append("files[" + key + "]", file.file);
      // });

      frmData.append("files", JSON.stringify(documents.map((file) => {
        return {
          name: file.name,
          type: file.type,
          size: file.size
        }
      })));

      const { data: result } = await http.post(
        config.ApplicantUploadDocument,
        frmData
      );

      docId = result?.uploadId;

      if (docId > 0) {
        await Promise.all(
          documents.map((file, key) => {
            if (!file.file) return Promise.resolve();
            return uploadFileToBlob(
              file.file,
              result.sasUrls[key].uploadUrl,
              (progress) => {
                console.log(`Upload progress for ${file.name}: ${progress}%`);
              }
            );
          })
        );
      }
    }

    const tmObj = {
      id: selectedObj.id,
      invoiceDocId: docId,
      notes: data["notes"],
      remarks: data["invNumber"],
      docUploadType: "agency",
    };

    await http.post(config.UpdateTimeLogInvoice, tmObj);
    handleInvShowHide("save");
    getAlert("Invoice Uploaded Successfully", "", "success");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await doSubmit();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    const docs = [
      ...documents,
      ...droppedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      })),
    ];
    setDocuments(docs);
  };

  const onFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const docs = [
      ...documents,
      ...selectedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      })),
    ];
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const { invShowHide, handleInvShowHide } = props;

  return (
    <Modal show={invShowHide} size="xl">
      <Modal.Header closeButton onClick={() => handleInvShowHide("")}>
        <Modal.Title>Upload Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">
          <div className="col-md-12">{renderInput("invNumber", "Invoice Number")}</div>

          <div className="col-md-12 form-group">
            <label className="form-control-label">Upload Invoice File</label>
            <div
              className={`drop-zone w-100 text-center border rounded ${isDragging ? "bg-light" : ""
                }`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
              style={{
                border: "2px dotted #666",
                borderRadius: "8px",
                padding: "30px",
                textAlign: "center",
                background: isDragging ? "#f0f8ff" : "#fafafa",
                cursor: "pointer",
                transition: "background 0.2s ease",
              }}
            >
              <i
                className="fa fa-cloud-upload fa-2x mb-2"
                aria-hidden="true"
                style={{ color: "black" }}
              ></i>
              <p className="mb-0">
                {isDragging
                  ? "Drop files here..."
                  : "Drag & drop invoice here, or click to select"}
              </p>
              <input
                type="file"
                ref={fileInputRef}
                onChange={onFileChange}
                multiple
                hidden
              />
            </div>

            {documents.length > 0 && (
              <div className="file-preview">
                {documents.map((file, index) => (
                  <div key={index} className="file-preview-item ml-1">
                    <span>{file.name}</span>
                    <span
                      className="file-size"
                      style={{
                        backgroundColor: "#f0f0f0",
                        marginLeft: "10px",
                        padding: "2px 5px",
                        borderRadius: "5px",
                      }}
                    >
                      {file.size} KB
                    </span>
                    <button
                      className="btn btn-sm btn-link"
                      onClick={() => handleFileRemove(file)}
                    >
                      <i className="fa fa-times text-red" aria-hidden="true"></i>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="col-md-12">{renderTextArea("notes", "Notes")}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-outline-default"
          onClick={handleSubmit}
        >
          <i className="fa fa-check"></i> Save
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default UploadInvoice;
